const hideOriginYaxisGridLine = (chart) => {
    const yAxesHavingGridLines = chart.axes.filter((axis) => !axis.isXAxis && axis.options.gridLineWidth);
    const firstGridLines = yAxesHavingGridLines.map((yAxis) => yAxis.gridGroup?.element?.children[0]);
    firstGridLines?.forEach((gridLine) => gridLine?.setAttribute?.("opacity", 0));
};
exports.hideOriginYaxisGridLine = hideOriginYaxisGridLine;
